import React from 'react';
import './Collectioncard.css';
import { Link } from 'react-router-dom';

function Collectioncard(props) {
  return (
    <div className='main-collection-card-wrap'>
        <Link to={`/product?category=${props.name.toLowerCase().replaceAll(" ", "+").replaceAll("&", "and")}`} className="nav-link collection-cardd d-flex flex-column align-items-center rounded-brand-esm p-0 overflow-hidden">
            <div className="p-0">
              <img src={props.img} alt={props.name} className="img-fluid category-img shadow-sm" style={{borderRadius: "10px", aspectRatio: '1/1', objectFit: 'cover', border: '3px solid white'}} />
            </div>
            <div className="text-center w-100 mt-2">
                <p className="mb-0 collection-btn rounded-brand cursor-pointer body-font-bold text-capitalize lh-sm fs-sm">{props.name}</p>
            </div>
        </Link>
    </div>
  )
}

export default Collectioncard